import axios, { AxiosError, GenericAbortSignal, Method } from 'axios'
import { HttpError } from '../errors'

export async function fetcher(path: string, method: Method, _data: any, _formData?: any, signal?: GenericAbortSignal) {
  try {
    let data
    let header
    if (_formData) {
      header = {
        enctype: 'multipart/form-data',
        'content-type': 'multipart/form-data'
      }
      data = _formData
    } else {
      header = { 'content-type': 'application/json' }
      data = _data
    }

    const response = await axios(path, {
      method,
      data,
      headers: { ...header },
      signal
    })

    /**
     * This case is handled because of keycloak session idle time (axios is not going to catch clausule)
     */
    if (response.status === 401) throw new HttpError('UNAUTHORIZED', response.status, 'UNAUTHORIZED')
    return response?.data
  } catch (e) {
    if (e instanceof AxiosError) {
      throw new HttpError(e.message, e.status, e.code)
    }

    throw new HttpError('Lamentamos, mas algo deu errado!', 404, '404')
  }
}
